import { Pagination } from './Pagination'
export class Function {
  private functionId: number
  private menuName: string

  constructor(functionId: number, menuName: string) {
    this.functionId = functionId
    this.menuName = menuName
  }
}

export class Role {
  private idRole: number
  private roleName: string
  private createdAt: string
  private updatedAt: string
  private access: object

  constructor(
    idRole: number,
    roleName: string,
    createdAt: string,
    updatedAt: string,
    access: object
  ) {
    this.idRole = idRole
    this.roleName = roleName
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.access = access
  }
}

export class RoleCMS {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: Role[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: Role[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
